import { CURRENCY_COOKIE } from '@/app/consts/cookies';
import { getCookie } from '@/utils/cookie';

import { useGeoContext } from '../contexts/GeoProvider';
import type { SupportedCurrency } from '../types/currency';

export default function useCurrency() {
  const { countryData } = useGeoContext();

  // Prioritize currency from cookie (set by URL param or user preference)
  // over country-based currency detection
  const currencyCookie = getCookie(CURRENCY_COOKIE as string);
  const currencyCode = (currencyCookie ??
    countryData?.currency) as SupportedCurrency;

  return {
    countryData,
    currencyCode,
  };
}
